var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whiteOffPersonal"},[_c('div',{staticClass:"text"},[_vm._v("请前往窗口或闸机进行验票")])])
}]

export { render, staticRenderFns }